<template>
  <div class="select-area">
    <div
      class="text-link-select-area"
      :class="{ 'select-area__error': hasErrors }"
    >
      <button :id="id" class="text-link" :name="name" :value="value">
        <span class="tl-plus-circle--left">
          {{ label }}
        </span>
      </button>
    </div>
    <ErrorMessages v-show="hasErrors" :errors="errors" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import ErrorMessages from '../form/ErrorMessages.vue'

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  value: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  errors: {
    type: Array,
    required: false,
    default: () => []
  }
})

const hasErrors = computed(() => props.errors.length > 0)
</script>

<style lang="scss" scoped>
.select-area {
  display: flex;
  flex-direction: column;

  .select-area__error {
    border: 1px solid $danger;
    box-sizing: border-box;
    margin-bottom: 0;
  }

  :deep(.error-message) {
    margin: 0;
    margin-top: 8px;
    text-align: left;
  }
}
</style>
